/**
 * Prénom affichable depuis un `display_name` (« Léa Martin » → « Léa »).
 * Garde les prénoms composés (« Jean-Pierre »), retombe sur `fallback` si vide.
 */
export function firstName(displayName: string | null | undefined, fallback = 'Toi'): string {
  const first = (displayName ?? '').trim().split(/\s+/)[0] ?? '';
  return first || fallback;
}
